/* eslint-disable operator-linebreak */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-throw-literal */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable no-underscore-dangle */
/* eslint-disable @typescript-eslint/lines-between-class-members */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable object-curly-newline */
/* eslint-disable no-alert */
/* eslint-disable no-console */
/* eslint-disable no-void */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable max-len */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable arrow-body-style */
/* eslint-disable import/no-cycle */
import React from "react";

import {
    CareerStatuses,
    CAREER_STATUS_APPLYING_ATTEND,
    CAREER_STATUS_APPLYING_CANCEL,
    CAREER_STATUS_BEFORE_PERIOD,
    CAREER_STATUS_UNLEARNED,
    CAREER_STATUS_LEARNING,
    CAREER_STATUS_DOING,
    CAREER_STATUS_APPLYING_RECORD,
    CAREER_STATUS_NOT_LEARNED,
    CAREER_STATUS_NOT_EXECUTED,
    CAREER_STATUS_APPLYING_EXECUTE,
    CURRICULUM_STATUS_APPLYING_ATTEND,
    CURRICULUM_STATUS_DOING,
    TRAINING_TYPE_CAREER,
} from "../../Constants";

import BaseFrame from "../../component/wrapper/BaseFrame";

import HomeSJ from "./HomeSJ";
import HomeDefault from "./HomeDefault";

import { getLayout } from "../../logic/companies/Companies";
import PwdWarningService, { PwdWarningResponse } from "../../logic/api/PwdWarningService";
import OnGoingGridListService, { OnGoingGridListItem } from "../../logic/api/OnGoingGridListService";
import OnGoingCULGridListService, { OnGoingCULGridListItem } from "../../logic/api/OnGoingCULGridListService";
import SearchCareerClassListService, { CareerResultsItem, SearchCareerClassListResponse } from "../../logic/api/SearchCareerClassListService";
import { useCategories2, Categories, CATEGORIES_DEFAULT } from "../../logic/hook/useCategories";
import { openInformationDialog, showErrorMessage } from "../../logic/hook/useDialogStateHelper";
import SompoContext from "../../logic/context/SompoContext";
import { currentDate, DateFormats, parseJSDateTime } from "../../logic/datetime";
import { statusMatches } from "../../logic/utility/TrainingUtil";

export interface Histories {
    careers: {
        onGoing: OnGoingGridListItem[];
    };
    curriculums: {
        onGoing: OnGoingCULGridListItem[];
    };
}

export interface HomeProps {
    categories: Categories;
    careers: CareerResultsItem[];
    histories: Histories;
}

const pwdWarningService = new PwdWarningService();
const onGoingService = new OnGoingGridListService();
const onGoingCULService = new OnGoingCULGridListService();
const searchService = new SearchCareerClassListService();

const HISTORIES_DEFAULT: Histories = {
    careers: {
        onGoing: [],
    },
    curriculums: {
        onGoing: [],
    },
};
const isDisplayCareer = (career: OnGoingGridListItem) => {
    const { displayStartDateTime, displayEndDateTime, jissiStartDateODT, jissiEndDateODT, careerTypeId } = career;
    const curDate = currentDate().getTime();
    const { status = "" } = career;

    if (
        statusMatches(status, [
            CareerStatuses[CAREER_STATUS_APPLYING_ATTEND], // 受講申請中
            CareerStatuses[CAREER_STATUS_APPLYING_EXECUTE], // 実施申請中(受講申請中として扱う)
            CareerStatuses[CAREER_STATUS_APPLYING_CANCEL], // 取消申請中
            CareerStatuses[CAREER_STATUS_APPLYING_RECORD], // 実績申請中
        ])
    ) {
        // 申請中は表示期間で判定
        if (
            displayStartDateTime &&
            displayEndDateTime &&
            curDate >= parseJSDateTime(displayStartDateTime, DateFormats.YYYYMMDDHHMM)!.getTime() &&
            curDate <= parseJSDateTime(displayEndDateTime, DateFormats.YYYYMMDDHHMM)!.getTime()
        ) {
            return true;
        }
    } else if (
        statusMatches(status, [
            CareerStatuses[CAREER_STATUS_UNLEARNED], // 未学習
            CareerStatuses[CAREER_STATUS_LEARNING], // 学習中
            CareerStatuses[CAREER_STATUS_DOING], // 実施中(学習中として扱う)
        ])
    ) {
        // 受講中は受講期間で判定
        if(
            careerTypeId === "2"&&
            jissiEndDateODT &&
            curDate <= parseJSDateTime(jissiEndDateODT, DateFormats.YYYYMMDDHHMM)!.getTime()){
            //集合研修の場合、受講申請承認後～受講期間開始までの間の期間を「受講中」に含めて表示する
            return true;
        }else if (
            jissiStartDateODT &&
            jissiEndDateODT &&
            curDate >= parseJSDateTime(jissiStartDateODT, DateFormats.YYYYMMDDHHMM)!.getTime() &&
            curDate <= parseJSDateTime(jissiEndDateODT, DateFormats.YYYYMMDDHHMM)!.getTime()
        ) {
            return true;
        }
    } else if (
        statusMatches(status, [
            CareerStatuses[CAREER_STATUS_BEFORE_PERIOD], // 期間前
        ])
    ) {
        // 期間前はすべてに表示するため残す
        return true;
    }
    return false;
};
const isDisplayCurriculum = (curriculum: OnGoingCULGridListItem) => {
    const { displayStartDateTime, displayEndDateTime } = curriculum;
    const curDate = currentDate().getTime();
    if (
        displayStartDateTime &&
        displayEndDateTime &&
        curDate >= parseJSDateTime(displayStartDateTime, DateFormats.YYYYMMDDHHMM)!.getTime() &&
        curDate <= parseJSDateTime(displayEndDateTime, DateFormats.YYYYMMDDHHMM)!.getTime()
    ) {
        return true;
    }
    return false;
};
const fetchPasswordWarning = async (needCheck: boolean): Promise<string | undefined> => {
    if (!needCheck) return "";

    let message;
    await pwdWarningService.pwdWarning(
        (response: PwdWarningResponse) => {
            message = response.message;
        },
        (error: any) => {
            console.error(error);
            throw { message: "パスワードの有効期限の確認に失敗しました。", error };
        }
    );
    return message;
};

const fetchCareers = async (): Promise<{
    careers: OnGoingGridListItem[];
    curriculums: OnGoingCULGridListItem[];
    careerClasses: CareerResultsItem[];
}> => {
    const errorHandler = (error: unknown) => {
        throw { message: "受講状況の取得に失敗しました。", error };
    };

    /* ====================================
     * 受講状況(講座)
     * ==================================== */
    // 受講履歴(実施中)
    const onGoing = await onGoingService.fetch().catch(errorHandler);
    const { onGoingGridList } = onGoing;

    // 表示対象のみにフィルタリング
    const careers = [...(onGoingGridList || []).filter((career) => isDisplayCareer(career))];

    /* ====================================
     * 受講状況(カリキュラム)
     * ==================================== */
    // 実施中：カリキュラム
    const { onGoingCULGridList } = await onGoingCULService.fetch().catch(errorHandler);

    // 表示対象のみにフィルタリング
    const curriculums = [...(onGoingCULGridList || []).filter((curriculum) => isDisplayCurriculum(curriculum))];

    /* ====================================
     * 講座の検索：新着用
     * ==================================== */
    let searched: CareerResultsItem[] = [];
    await searchService.searchCareerClassList(
        {
            careerType: TRAINING_TYPE_CAREER,
            elearning: true,
            shugo: true,
            tuusin: false,
        },
        (response: SearchCareerClassListResponse) => {
            searched = response.careerResults || [];
        },
        errorHandler
    );

    return {
        careers,
        curriculums,
        careerClasses: searched,
    };
};

const fetch = async (
    homeVisited: boolean
): Promise<{
    passwordWarning: string | undefined;
    careerHistories: OnGoingGridListItem[];
    curriculumHistories: OnGoingCULGridListItem[];
    careerClasses: CareerResultsItem[];
    categories: Categories;
}> => {
    // ログイン後の初回表示時にのみ、パスワード有効期限警告のチェックを行う
    const passwordWarning = await fetchPasswordWarning(!homeVisited);

    // 講座・カリキュラムの状況
    const { careers, curriculums, careerClasses: searched } = await fetchCareers();

    // 分類
    const { fetchCategories } = useCategories2();
    const categories: Categories = await fetchCategories();

    return {
        passwordWarning,
        careerHistories: careers,
        curriculumHistories: curriculums,
        careerClasses: searched,
        categories,
    };
};

const Content = () => {
    const sompoContext = React.useContext(SompoContext); // ローディングアニメーションの表示用
    const [categories, setCategories] = React.useState<Categories>(CATEGORIES_DEFAULT);
    const [careers, setCareers] = React.useState<CareerResultsItem[]>([]);
    const [histories, setHistories] = React.useState<Histories>(HISTORIES_DEFAULT);

    React.useEffect(() => {
        sompoContext.setLoading(true);

        const _fetch = async () => {
            try {
                const {
                    passwordWarning: message,
                    careerHistories,
                    curriculumHistories,
                    careerClasses,
                    categories: _categories,
                } = await fetch(sompoContext.homeVisited);

                // Set states.
                // 条件付き有効期限のダイアログ表示 ローカル変数がいい
                if (message) {
                    openInformationDialog({ message });
                }
                setHistories({
                    careers: {
                        onGoing: careerHistories,
                    },
                    curriculums: {
                        onGoing: curriculumHistories,
                    },
                });
                setCategories(_categories);
                setCareers(careerClasses);
                sompoContext.setHomeVisited(true); // 表示実績をありに変更
                sompoContext.setLoading(false); // ローディング終了
            } catch (error: any) {
                console.error(error.error);
                showErrorMessage({ message: error.message, error: error.error });
                setCategories(CATEGORIES_DEFAULT);
                setCareers([]);
                sompoContext.setHomeVisited(true); // 表示実績をありに変更
                sompoContext.setLoading(false); // ローディング終了
            }
        };
        void _fetch();
    }, []);

    const layout = getLayout();
    switch (layout) {
        case "2":
            return <HomeSJ categories={categories} careers={careers} histories={histories} />;
        default:
            return <HomeDefault categories={categories} careers={careers} histories={histories} />;
    }
};

const Home = () => <BaseFrame content={<Content />} />;

export default Home;
